import { ReactNode } from "react";

import { DefaultCommunityImage } from "~/modules/Common/Image/components/DefaultCommunityImage/DefaultCommunityImage";
import { toBackgroundImages } from "~/utils/converter";
import { CoverImageWithGradient } from "~/_components/CoverImageWithGradient/CoverImageWithGradient";
import { EDevice } from "~/_enums/EDevice";

type Props = {
  children: ReactNode;
  coverImageUrl: string | null;
  categoryId: string;
};
export const CommunityInviteBackground = ({
  children,
  coverImageUrl,
  categoryId,
}: Props) => {
  return (
    <div className="flex-center relative h-screen w-full">
      <div className="absolute top-0 left-0 aspect-[120/31.25] w-full">
        <CoverImageWithGradient
          image={
            coverImageUrl ?? (
              <DefaultCommunityImage
                type={toBackgroundImages(categoryId)}
                className={
                  "absolute left-0 top-0 h-full w-full !bg-cover !bg-center"
                }
              />
            )
          }
          variant={EDevice.Desktop}
        />
      </div>
      {children}
    </div>
  );
};
